import { render } from "./ButtonUp.vue?vue&type=template&id=35d4860e&lang=pug"
import script from "./ButtonUp.vue?vue&type=script&lang=js"
export * from "./ButtonUp.vue?vue&type=script&lang=js"

import "./ButtonUp.sass?vue&type=style&index=0&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__